import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  CANCEL: `${cleanedFilename(__filename)}-cancel`,
  SUBMIT: `${cleanedFilename(__filename)}-submit`,
  TEXTAREA: `${cleanedFilename(__filename)}-textarea`,
};
